// src/theme/tokens.js — V18 design tokens (mirrors the Foundations artboard).

export const color = {
    void: '#070205',
    surface: '#0f0509',
    surface2: '#170a0f',
    line: 'rgba(234, 225, 222, 0.12)',
    line2: 'rgba(234, 225, 222, 0.24)',
    text: '#EAE1DE',
    textBright: '#F4E8E4',
    text2: '#B8A6A7',
    text3: '#8E7A7B',
    blood: '#C8323E',
    bloodHi: '#E0464F',
    onBlood: '#FFF4F0',
    denpa: '#7FD6D0',
};

export const font = {
    display: "'Shippori Mincho B1', 'Noto Serif SC', 'Songti SC', serif",
    body: "'Noto Serif SC', 'Shippori Mincho B1', 'Songti SC', serif",
    mono: "'JetBrains Mono', ui-monospace, monospace",
};

export const HEADER_HEIGHT = 64;

// halftone screen shared by CG backplates and the WebGL layer
export const halftone = `
    background-image: radial-gradient(rgba(7, 2, 5, 0.9) 0.9px, transparent 1.4px);
    background-size: 4px 4px;
    mix-blend-mode: multiply;
`;
